import { Controller } from "@hotwired/stimulus"

// `.tokenfield()` is bootstrap-tokenfield, a jQuery plugin: it dispatches
// "tokenfield:createtoken"/"tokenfield:createdtoken" through jQuery's own `.trigger()`, which no
// data-action would ever see, so those stay bound with jQuery inside connect().
export default class extends Controller {
  static get values() {
    return { source: String };
  }

  connect() {
    this.tokens = this.sourceValue.split(",");
    this.$element = $(this.element);
    this.discardRestoredWidget();

    this.$element.tokenfield({
      autocomplete: {
        source: this.tokens,
        delay: 100
      },
      beautify: false,
      createTokensOnBlur: true,
      showAutocompleteOnFocus: true
    });

    this.onCreateToken = this.onCreateToken.bind(this);
    this.onCreatedToken = this.onCreatedToken.bind(this);
    this.$element.on("tokenfield:createtoken", this.onCreateToken);
    this.$element.on("tokenfield:createdtoken", this.onCreatedToken);
  }

  disconnect() {
    this.$element.off("tokenfield:createtoken", this.onCreateToken);
    this.$element.off("tokenfield:createdtoken", this.onCreatedToken);
  }

  // Removes a widget restored from Turbo's cache so tokenfield doesn't wrap it twice.
  discardRestoredWidget() {
    const widget = this.element.closest("div.tokenfield");
    if (!widget || this.$element.data("bs.tokenfield")) {
      return;
    }

    widget.replaceWith(this.element);
    ["position", "left", "right"].forEach((property) => this.element.style.removeProperty(property));
    this.element.removeAttribute("tabindex");
  }

  onCreateToken(e) {
    const val = e.attrs.value;
    // don't allow tags that don't already exist
    if (this.tokens.indexOf(val) < 0) {
      return false;
    }

    // Prevent duplicate tags, which will also help us solve the issue of a
    // bug in bootstrap-tokenfield
    // https://github.com/sliptree/bootstrap-tokenfield/issues/308
    const existingTokens = this.$element.tokenfield("getTokens");
    $.each(existingTokens, (index, token) => {
      if (token.value === e.attrs.value) {
        e.preventDefault();
        this.reopenAutocomplete();
      }
    });
  }

  onCreatedToken() {
    this.reopenAutocomplete();
  }

  reopenAutocomplete() {
    setTimeout(() => {
      // hack to make the autocomplete menu re-appear after a token is created
      // native blur/focus/click dispatch real DOM events, which jQuery UI's
      // autocomplete listens for the same as any other native listener would
      const tf = document.getElementById(this.element.id + "-tokenfield");
      tf.blur();
      tf.focus();
      tf.click();
    }, 0);
  }
}
